import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8787';

export interface ProgressData {
    uploadId: string;
    fileName: string;
    status: 'downloading' | 'uploading' | 'completed' | 'failed';
    stage: string;
    downloadProgress: number;
    uploadProgress: number;
    totalBytes: number;
    processedBytes: number;
    error?: string;
    startTime: number;
    lastUpdate: number;
    driveFileId?: string;
    driveLink?: string;
}

/**
 * 获取上传进度
 */
export async function fetchProgress(uploadId: string): Promise<ProgressData | null> {
    try {
        const response = await axios.get<{ success: boolean; data: ProgressData }>(
            `${API_BASE_URL}/api/progress/${uploadId}`,
            { timeout: 5000 }
        );
        return response.data.data;
    } catch (error) {
        console.error('Error fetching progress:', error);
        return null;
    }
}
